module.exports = __webpack_public_path__ + "img/quotes.28fdc242.svg";